import moment from 'moment-with-locales-es6';
import Swiper from 'swiper';
import 'hammerjs/hammer';
import jQueryBridget from 'jquery-bridget';
import Masonry from 'masonry-layout';
jQueryBridget("masonry", Masonry, $);
// JavaScript Document

$(function() {
	if ( $( "#eventsSlider" ).length ) {
		/*
			EVENTS SLIDER
			*/
		var linkAllEventsInitial = $('.dateSliderBtnMore').attr('href');
		var eventsSliderNode = $('#eventsSlider .dateSliderDatesWrap'),
			eventsSliderAjaxRqst,
			eventsSliderSlideChangeTimer = null,
			eventsSliderEventsNode = $('#eventsSlider .dateSliderEvents'),
			eventsSliderEventsMc = new Hammer.Manager(eventsSliderEventsNode[0]),
			eventsSwiper = new Swiper(eventsSliderNode.get(0), {
				spaceBetween: 0,
				slidesPerView: 'auto',
				grabCursor: true,
				freeMode: true,
				freeModeSticky: true,
				wrapperClass: 'dateSliderDates'
			}),
			eventsSliderMonths = eventsSliderNode.find('.dateSliderMonth'),
			eventsSliderNextBtn = $('#eventsSlider .dateSliderButtonNext').on('click', function () {
				var newLeft = eventsSwiper.getTranslate() - eventsSwiper.width;
				eventsSwiper.slideTo(eventsSliderGetIndex(newLeft));
			}),
			eventsSliderLastStickyMonth = 0,
			eventsSliderGetIndex = function (left) {
				var newIndex = 0;

				for (var i = 0; i < eventsSwiper.slides.length; i++) {
					newIndex = i;
					if ($(eventsSwiper.slides[i]).position().left > Math.abs(left)) {
						newIndex -= 3;
						if (newIndex < 0) {
							newIndex = 0;
						}
						break;
					}
				}

				return newIndex;
			},
			eventsSliderStickyMonthChange = function (index) {
				eventsSliderNode.find('.dateSliderMonth.sticky').remove();
				eventsSliderMonths.eq(index).clone().appendTo(eventsSliderNode).wrap('<ul class="dateSliderMonthSticky"></ul>').addClass('sticky');

				eventsSliderLastStickyMonth = index;
			},
			eventsSliderGetEvents = function (node) {
				if (eventsSliderAjaxRqst && ('readyState' in eventsSliderAjaxRqst) && eventsSliderAjaxRqst.readyState != 4) {
					eventsSliderAjaxRqst.abort();
				}

				eventsSliderEventsNode.height(eventsSliderEventsNode.height()).empty();

				$('<div class=\"loading\"></div>').appendTo(eventsSliderEventsNode);


				//Build link for API Request
				var currentDate = node.parent().data("date");
				moment.locale('de');
				var deDate = moment(currentDate, "YYYY-MM-DD").format("DD.MM.YYYY");
				var humanDate = moment(currentDate, "YYYY-MM-DD").format("LLL");
				var event_day = moment(currentDate, "YYYY-MM-DD").format("DD");
				var event_month = moment(currentDate, "YYYY-MM-DD").format("MM");
				var event_year = moment(currentDate, "YYYY-MM-DD").format("YYYY");
				var apiLink = "https://www-test.forst-lausitz.de/api/EventApi.php?limit=2&year=" + event_year + "&month=" + event_month + "&day=" + event_day;


				eventsSliderAjaxRqst = $.getJSON(apiLink, {action: 'events_getEventsByDate'}, function (data) {
					if (data.length === 0) {
						eventsSliderEventsNode.append('<article class="clearfix event">Keine Veranstaltungen an diesem Tag.</article>');
						//Add amount of events for this day
						$('.dateSliderBtnMore .counter').text("0");
						//Reset Link to further events
						$('.dateSliderBtnMore').attr('href', linkAllEventsInitial);
					} else {
						$.each(data, function (index, element) {
							//Add amount of events for this day
							$('.dateSliderBtnMore .counter').text(element.eventsAll);
							//put date-GET-Parameters to link to all events of this day and replace link
							var linkAllEvents = linkAllEventsInitial + '?dateFrom=' + deDate + '&dateTo=' + deDate;
							$('.dateSliderBtnMore').attr('href', linkAllEvents);

							var eventStartDate = moment(element.startDate).format("LL");
							eventsSliderEventsNode.append('<article class="clearfix event"><div class="eventInfo"><ul class="eventData clearfix letterSpacing"><li>' + eventStartDate + '</li><li>' + element.startTime + '</li><li>' + element.location + '</li></ul><h3 class="headline"><a href="' + element.url + '" target="_self">' + element.title + '</a></h3><a class="btnMore btn" href="' + element.url + '" target="_self" title="mehr">mehr</a></div></article>');
						});
					}
				}).always(function () {
					eventsSliderNode.find('.dateSliderDate').removeClass('active');
					node.parent().addClass('active');

					eventsSliderEventsNode.find('.loading').remove();
					eventsSliderEventsNode.css('height', '');
				});
			};

		eventsSwiper.on('transitionEnd transitionStart sliderMove', function () {
			var left = eventsSwiper.getTranslate();
			for (var i = 0; i < eventsSliderMonths.length; i++) {
				var currentLeft = eventsSliderMonths.eq(i).position().left;

				if (eventsSliderMonths.eq(i).position().left > Math.abs(left)) {
					var index = Math.max(0, i - 1);
					if (index != eventsSliderLastStickyMonth) {
						eventsSliderStickyMonthChange(index);
					}
					break;
				}
			}
		});

		/*
			find the next possible node in viewport and set it active/get events
			*/
		eventsSwiper.on('slideChange', function (event) {
			if (eventsSliderSlideChangeTimer != null) {
				clearTimeout(eventsSliderSlideChangeTimer);
			}

			eventsSliderSlideChangeTimer = setTimeout(function () {
				var currentIndex = Math.min(eventsSwiper.realIndex + 2, eventsSwiper.slides.length),
					hasActive = false,
					firstPossibleActive = false,
					rightEdge = Math.abs(eventsSwiper.getTranslate()) + eventsSwiper.width;

				for (var i = currentIndex; i < eventsSwiper.slides.length; i++) {
					var node = $(eventsSwiper.slides[i]);

					if (node.hasClass('active')) {
						hasActive = true;
						break;
					}

					if (node.hasClass('hasEvents') && firstPossibleActive === false) {
						firstPossibleActive = node;
					}

					if (node.position().left > rightEdge) {
						break;
					}
				}

				if (hasActive === false && firstPossibleActive !== false) {
					firstPossibleActive.find('a').trigger('click');
				}
			}, 1000);
		});

		eventsSliderStickyMonthChange(eventsSliderLastStickyMonth);

		eventsSliderNode.find('.dateSliderDate a').on('click', function (event) {
			event.preventDefault();

			eventsSliderGetEvents($(this));
		});

		if (eventsSliderNode.find('.dateSliderDate.active').length != 0) {
			var newLeft = eventsSliderNode.find('.dateSliderDate.active').position().left;
			eventsSwiper.slideTo(eventsSliderGetIndex(newLeft));
		}

		eventsSliderEventsMc.add(new Hammer.Pan({
			threshold: 10,
			pointers: 1,
			direction: Hammer.DIRECTION_HORIZONTAL
		}));
		eventsSliderEventsNode.on('panend', function (event) {
			var currentActiveNode = eventsSliderNode.find('.dateSliderDate.active'),
				newNode;
			if (currentActiveNode.length != 0) {
				if (event.gesture.additionalEvent == 'panleft') {
					newNode = currentActiveNode.nextAll('.hasEvents');
				} else {
					newNode = currentActiveNode.prevAll('.hasEvents');
				}

				if (newNode.length != 0) {
					newNode.eq(0).find('a').trigger('click');
					var newLeft = newNode.position().left;
					eventsSwiper.slideTo(eventsSliderGetIndex(newLeft));
				}
			}
		});

		//Trigger inital Click on "today"
		if ($("#eventsSlider .today").length) {
			$("#eventsSlider .today a").click();
		}
	}
});

$(function() {
	/*
		MASONRY GRIDS
		*/
	$('.masonryWrap').each(function() {
		var msnry = $(this);
		
		$('<div class="masonryGridSizer"></div>').prependTo(msnry);
		msnry.find('> .clear').remove();
		
		msnry.addClass('hasMasonry').masonry({
			itemSelector: '.masonryGridItem',
			columnWidth: '.masonryGridSizer',
			percentPosition: true,
			resize : true
		});
		
		msnry.masonry();
	});

});

$(function() {
	/*
		QUICK BOOKING FORM
		*/
	var dates = $('#qb_arrival, #qb_departure'),
		dateOpts = {
			defaultDate: '+0d',
			minDate: '+1d',
			dateFormat: 'dd.mm.yy',
			numberOfMonths: 1,
			showOn: "focus",
			constrainInput: true,
			buttonImageOnly: false,
			changeMonth: true,
			changeYear: true,
			onSelect: function( selectedDate ) {
				var option = this.id == 'qb_arrival' ? 'minDate' : 'maxDate',
					instance = $(this).data('datepicker'),
					date = $.datepicker.parseDate(
						instance.settings.dateFormat ||
						$.datepicker._defaults.dateFormat,
						  selectedDate, instance.settings);
				
				if (date==null && option=='minDate') {
					dates.not(this).datepicker('option', option, new Date(0));
				} else if (option=='minDate') {
					date.setTime(date.getTime()+(86400000));
					dates.not(this).datepicker('option', option, date);
				}
				
				if (option=='minDate' && dates.not(this).datepicker('getDate')==null) {
					dates.not(this).datepicker('setDate', date);
					setTimeout( function() {
						dates.not(this).trigger('focus');
					}, 10);
				}
				
				$(this).trigger('change');
			}
		};
		
	dates.each(function() {
		var node = $(this),
			parent = node.closest('.optsContainer'),
			check = function() {
				if (node.val()!='') {
					parent.addClass('hasValue');
				} else {
					parent.removeClass('hasValue');
				}
			};

		node
			.datepicker(dateOpts)
			.attr('readonly', true) /* prevent keyboard from poping up on focus */
			.on('change', function() {
				 check();
			}).on('focus',function() {
				parent.addClass('hasFocus');
			}).on('blur',function() {
				parent.removeClass('hasFocus');
			});
					
		check();
	});
	
	dates.datepicker('option', $.datepicker.regional['de']);
	dates.datepicker('option', 'dateFormat', dateOpts.dateFormat);
});